"use client"

import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"

interface OAuthCallbackResult {
  isProcessing: boolean
  errorOAuth: string | null
  successOAuth: boolean
  provider: string | null
  tenantId: string | null
}

export const useOAuthCallback = (): OAuthCallbackResult => {
  const [isProcessing, setIsProcessing] = useState(true)
  const [errorOAuth, setError] = useState<string | null>(null)
  const [successOAuth, setSuccess] = useState(false)
  const [provider, setProvider] = useState<string | null>(null)
  const [tenantId, setTenantId] = useState<string | null>(null)

  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const processOAuthCallback = async () => {
      try {
        const urlParams = new URLSearchParams(location.search)
        const tanent = urlParams.get("tanent")
        const hubspotState = urlParams.get("hubspot")
        const salesforceState = urlParams.get("salesforce")
        const errorParam = urlParams.get("error")
        console.log(urlParams, tanent, hubspotState, errorParam, salesforceState)
        if (errorParam) {
          setError("Authentication was cancelled or failed")
          setIsProcessing(false)
          return
        }
        // Determine provider from state or URL path
        const providerFromState = hubspotState?.includes("true") && salesforceState?.includes("false")
          ? "hubspot"
          : hubspotState?.includes("true") && salesforceState?.includes("true")
            ? "salesforce"
            : null

        if (!providerFromState) {
          setError("Invalid authentication state")
          setIsProcessing(false)
          return
        }

        // Store the connection status in localStorage
        const connectionKey = `${providerFromState}_connected`
        const tenantKey = `${providerFromState}_tenant_id`

        // Extract tenant ID from URL if available (for HubSpot)
        const tenantIdFromUrl = urlParams.get("tenant_id") || (providerFromState === "hubspot" ? "242369133" : null)

        localStorage.setItem(connectionKey, "true")
        if (tenantIdFromUrl) {
          localStorage.setItem(tenantKey, tenantIdFromUrl)
        }

        setProvider(providerFromState)
        setTenantId(tenantIdFromUrl)
        setSuccess(true)
        setIsProcessing(false)

        // Redirect to success page after a short delay
        // setTimeout(() => {
        //   navigate(`/dashboard/auth-success?provider=${providerFromState}&tenant_id=${tenantIdFromUrl}`)
        // }, 1000)
      } catch (err) {
        console.error("OAuth callback error:", err)
        setError("Failed to process authentication")
        setIsProcessing(false)
      }
    }

    // Only process if we have query parameters
    if (location.search) {
      processOAuthCallback()
    } else {
      setIsProcessing(false)
    }
  }, [location.search, navigate])

  return {
    isProcessing,
    errorOAuth,
    successOAuth,
    provider,
    tenantId,
  }
}
